// WW-CUSTOM: checkout only after the terms are accepted, in the cart drawer and on the cart page
const WW_CHECKOUT_TRIGGERS = 'a[href*="/checkout"], [name="checkout"]';

class WwCartTerms extends HTMLElement {
  connectedCallback() {
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.dialog = this.querySelector('dialog');

    this.checkbox.addEventListener('change', () => this.save());
    this.querySelector('[data-ww-terms-accept]').addEventListener('click', () => this.accept());
    this.querySelector('[data-ww-terms-cancel]').addEventListener('click', () => this.dialog.close());
    // The dialog has no padding of its own, so a click that lands on it is a click on the backdrop.
    this.dialog.addEventListener('click', (event) => event.target === this.dialog && this.dialog.close());
    this.dialog.addEventListener('cancel', () => {
      // The dialog closes on keydown; the matching keyup would otherwise also close the cart drawer.
      window.addEventListener('keyup', (event) => event.key === 'Escape' && event.stopPropagation(), { capture: true, once: true });
    });
  }

  gate(trigger, event) {
    if (this.checkbox.checked && !this.saving) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    this.trigger = trigger;
    if (this.checkbox.checked) {
      this.saving.then(() => this.trigger.click());
    } else {
      this.dialog.showModal();
    }
  }

  async accept() {
    this.checkbox.checked = true;
    this.dialog.close();
    await this.save();
    this.trigger?.click();
  }

  // Stored on the cart so the order shows when the terms were accepted, and so the box stays ticked when the
  // drawer re-renders. Checkout waits for it, but a failed save never blocks the purchase.
  save() {
    const saving = fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { terms_accepted: this.checkbox.checked ? new Date().toISOString() : '' } }),
    })
      .catch(() => {})
      .finally(() => {
        if (this.saving === saving) this.saving = null;
      });
    this.saving = saving;
    return saving;
  }
}

if (!customElements.get('ww-cart-terms')) {
  customElements.define('ww-cart-terms', WwCartTerms);

  // One listener on the document, because the cart drawer is re-rendered on every cart change.
  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest(WW_CHECKOUT_TRIGGERS);
      trigger?.closest('.shopify-section')?.querySelector('ww-cart-terms')?.gate(trigger, event);
    },
    true
  );
}
